import { CopyButton } from "@stacklet/ui";

interface Props {
  /** The command or config to show, copied verbatim. */
  value: string;
  /** What the copy button's tooltip calls this snippet, e.g. "command". */
  copyLabel: string;
}

/**
 * A copyable command or config block. Deliberately not `CodeBlock`: these are
 * single commands the user pastes into a terminal rather than policy source,
 * so they need neither syntax highlighting nor an expand-to-dialog control.
 */
export function McpSnippet({ value, copyLabel }: Props) {
  return (
    <div className="flex items-start justify-between gap-xs rounded-xs bg-background-secondary p-xs">
      {/*
        The copy button stands 24px against an 18px line of mono-small, so the
        text carries the 3px difference on each side. Its first line then
        centres on the button whatever the value does — one line, several, or
        one long enough to wrap — and a one-line snippet sits centred in the
        box instead of riding its top. There is no 3px spacing token; the
        number is the button's height minus a line, halved.
      */}
      <pre className="min-w-0 flex-1 whitespace-pre-wrap break-all py-[3px] font-mono text-mono-small text-text-secondary">
        {value}
      </pre>
      <CopyButton copyLabel={copyLabel} value={value} />
    </div>
  );
}
